import { Record as record } from 'immutable';

import ValidationMixin from '../ValidationMixin';
import validators from '../../validation';

const defaults = {
    railcardNumber: null,
    firstName: null,
    lastName: null,
    syncKeyGo: null,
    expiryDate: null,
};

class Railcard1617Form extends record(defaults) {
    getSchema () {
        return {
            railcardNumber: validators.requiredString(15),
            firstName: validators.required(),
            lastName: validators.required(),
            syncKeyGo: validators.optional(),
            expiryDate: validators.required(),
        };
    }
}

Object.assign(Railcard1617Form.prototype, ValidationMixin);

export default Railcard1617Form;
